var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaggedAndVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3295 2.3284C11.3295 2.14145 11.2261 1.96985 11.062 1.88154C10.8978 1.79354 10.6972 1.80403 10.5422 1.90753C10.5148 1.9241 7.83216 3.67975 6.12226 1.96985C4.26189 0.109325 1.58076 1.11855 0.421071 1.91042C0.282759 2.00466 0.200684 2.16121 0.200684 2.3284V14.4681C0.200684 14.7478 0.427151 14.9741 0.706814 14.9741C0.986478 14.9741 1.21295 14.7478 1.21295 14.4681V9.18335C1.88323 8.78954 3.93663 7.79096 5.4079 9.26072C7.22572 11.0785 9.9266 10.0997 11.1015 9.32607C11.2428 9.23184 11.3295 9.07377 11.3295 8.90354V2.3284Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedAndVerified);
export default __webpack_public_path__ + "static/media/flagged-and-verified.faa730eff07c70137028ab545b6268b8.svg";
export { ForwardRef as ReactComponent };